import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AccordionItem as Item } from './AccordionItem';
import { AccordionWrapper, AccordionContent, DetailBody } from './styles';

export const Accordion = ({
  details,
  variant = 'default',
  buttonVariant = 'kale',
}) => {
  const [activeItem, setActiveItem] = useState(0);

  const onSelectItem = index => {
    setActiveItem(index === activeItem ? null : index);
  };

  return (
    <AccordionWrapper>
      {details.map(({ title, body }, index) => (
        <Item
          title={title}
          key={title}
          variant={variant}
          buttonVariant={buttonVariant}
          isOpen={index === activeItem}
          onClick={() => onSelectItem(index)}
        >
          <AccordionContent>
            <DetailBody>{body}</DetailBody>
          </AccordionContent>
        </Item>
      ))}
    </AccordionWrapper>
  );
};

Accordion.propTypes = {
  details: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      body: PropTypes.node.isRequired,
    }),
  ).isRequired,
  variant: PropTypes.string,
  buttonVariant: PropTypes.string,
};
